// -----------------------------------------------------------------------------
// Library
// -----------------------------------------------------------------------------
import dayjs from "dayjs";
import React, { useState } from "react";
import { DatePicker } from "antd";

// -----------------------------------------------------------------------------
// Components
// -----------------------------------------------------------------------------
import { MembersSubscribersDonutChart } from "components/Members/MembersSubscribersDonutChart";
import { MembersSubscribersStackedBarChart } from "components/Members/MembersSubscribersStackedBarChart";
import { MembersTable } from "components/Members/MembersTable";
import { Heading3 } from "themes/default/_typography";
import moment from "moment";

// -----------------------------------------------------------------------------
// Styles
// -----------------------------------------------------------------------------
import StyledCategories from "./styles";
import { Tag } from "antd/lib";
// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------
const Members = () => {
	const { RangePicker } = DatePicker;

	const dateRangeInitState = {
		startDate: dayjs().startOf("month"),
		endDate: dayjs().endOf("month"),
	};

	const [dateRange, setDateRange] = useState(dateRangeInitState);

	const onDateRangeChange = (dates) => {
		if (dates) {
			setDateRange({
				startDate: dates[0],
				endDate: dates[1],
			});
		} else {
			setDateRange(dateRangeInitState);
		}
	};

	const resetDates = (e) => {
		e.preventDefault();
		setDateRange(dateRangeInitState);
	};

	const isDefaultRangeOfMonths =
		moment(dateRange.startDate.toDate()).format("YYYY-MM-DD") ===
			moment(dateRangeInitState.startDate.toDate()).format("YYYY-MM-DD") &&
		moment(dateRange.endDate.toDate()).format("YYYY-MM-DD") ===
			moment(dateRangeInitState.endDate.toDate()).format("YYYY-MM-DD");

	return (
		<StyledCategories className="sb-members-page">
			<div className="sb-members-page__subscribers" data-id="sectionSubscribers">
				<div className="sb-members-page__subscribers__heading">
					<Heading3>Subscribers</Heading3>
					<div className="sb-members-page__subscribers__heading__date-filter" data-id="sectionSubscribersDateFilter">
						<RangePicker
							defaultValue={[dateRange.startDate, dateRange.endDate]}
							allowClear
							popupStyle={{ zIndex: 99999 }}
							presets={[
								{
									label: "Last Month",
									value: [dayjs().startOf("month").subtract(1, "months"), dayjs().startOf("month").subtract(1, "days")],
								},
								{
									label: "This Month",
									value: [dayjs().startOf("month"), dayjs().endOf("month")],
								},
								{
									label: "Last Year",
									value: [dayjs().startOf("year").subtract(1, "years"), dayjs().startOf("year").subtract(1, "days")],
								},
								{
									label: "This Year",
									value: [dayjs().startOf("year"), dayjs().endOf("year")],
								},
							]}
							onChange={onDateRangeChange}
							popupClassName="custom-picker-range-popup-responsive"
							getPopupContainer={(trigger) => trigger.parentNode}
							data-id="datePickerFilter"
						/>
					</div>
				</div>
				<div className="sb-members-page__subscribers__filter">
					<Tag
						closable={!isDefaultRangeOfMonths}
						onClose={resetDates}
						bordered={false}
						style={{
							backgroundColor: `var(--background-color)`,
							borderRadius: 100,
							padding: '1px 8px'
						}}
					>
						<span
							style={{
								color: `var(--primary-color)`,
							}}
						>
							{moment(dateRange.startDate.toDate()).format("YYYY-MM-DD")} -{" "}
							{moment(dateRange.endDate.toDate()).format("YYYY- MM-DD")}
						</span>
					</Tag>
				</div>
				<div className="sb-members-page__subscribers__charts" data-id="sectionSubscribersCharts">
					<div className="sb-members-page__subscribers__charts__donut" data-id="sectionSubscribersDonut">
						<MembersSubscribersDonutChart dateRange={dateRange} />
					</div>
					<div
						className="sb-members-page__subscribers__charts__stacked-bar-chart"
						data-id="sectionSubscribersStackedBarChart"
					>
						<MembersSubscribersStackedBarChart
							dateRange={{
								startDate: moment(dateRange.startDate.toDate()),
								endDate: moment(dateRange.endDate.toDate()),
							}}
						/>
					</div>
				</div>
				<div className="sb-members-page__subscribers__table">
					<MembersTable dateRange={dateRange} />
				</div>
			</div>
		</StyledCategories>
	);
};

export default Members;
